import React from 'react';
import './Add.css';

export default function Add(props) {
  return (
    <p className='ele'>{props.array}</p>
    
  )
}
